import { getPreviousDate, getMonth, getQuarter, getYear } from "@ui-seeker/utils"


const currentDay = new Date().getDay()
const currentDayOfMonth = new Date().getDate()
const currentMonth = getMonth()
const currentYear = getYear()
const currentQuarter = getQuarter()

const lastQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1
const lastQuarterMonth = lastQuarter * 3
const lastQuarterYear = currentQuarter === 1 ? currentYear - 1 : currentYear

export const YESTERDAY_DATE = new Date(new Date().setHours(0,0,0,0) - 24*60*60*1000)

export const DATE_PERIODS = {
    TODAY: 'today',
    YESTERDAY: 'yesterday',
    LAST_7_DAYS: 'last7days',
    LAST_14_DAYS: 'last14Days',
    LAST_30_DAYS: 'last30Days',
    LAST_60_DAYS: 'last60Days',
    LAST_90_DAYS: 'last90Days',
    LAST_180_DAYS: 'last180Days',
    LAST_365_DAYS: 'last365Days',
    LAST_MONTH: 'lastMonth',
    LAST_3_MONTHS: 'last3Months',
    LAST_QUARTER: 'lastQuarter',
    LAST_YEAR: 'lastYear',
    YEAR_TO_DATE: 'yearToDate',
    MONTH_TO_DATE: 'monthToDate',

    TOMORROW: 'tomorrow',
    NEXT_7_DAYS: 'next7Days',
    NEXT_30_DAYS: 'next30Days',
    NEXT_60_DAYS: 'next60Days',
    NEXT_90_DAYS: 'next90Days',
    NEXT_MONTH: 'nextMonth',
    NEXT_QUARTER: 'nextQuarter',
    YEAR_AHEAD: 'yearAhead',
    CURRENT_YEAR: 'currentYear',

    CUSTOM: 'custom'
}

export const PREVIOUS_PERIODS = {
    [DATE_PERIODS.YESTERDAY]: [getPreviousDate({ days: 2 }), getPreviousDate({ days: 2 })],
    [DATE_PERIODS.LAST_7_DAYS]: [getPreviousDate({ days: 14 }), getPreviousDate({ days: 8 })],
    [DATE_PERIODS.LAST_14_DAYS]: [getPreviousDate({ days: 28 }), getPreviousDate({ days: 15 })],
    [DATE_PERIODS.LAST_30_DAYS]: [getPreviousDate({ days: 60 }), getPreviousDate({ days: 31 })],
    [DATE_PERIODS.LAST_60_DAYS]: [getPreviousDate({ days: 120 }), getPreviousDate({ days: 61 })],
    [DATE_PERIODS.LAST_90_DAYS]: [getPreviousDate({ days: 180 }), getPreviousDate({ days: 91 })],

    [DATE_PERIODS.LAST_MONTH]: [
        getPreviousDate({ months: 1 }, new Date(currentYear, currentMonth - 2, 1)),
        getPreviousDate({ days: 1 },  new Date(currentYear, currentMonth - 2, 1))
    ],
    [DATE_PERIODS.LAST_QUARTER]: [
        new Date(lastQuarterYear, lastQuarterMonth - 6, 1),
        new Date(lastQuarterYear, lastQuarterMonth - 3, 0)
    ],
    [DATE_PERIODS.YEAR_TO_DATE]: [
        new Date(currentYear - 1, 0, 1),
        new Date(currentYear - 1, currentMonth - 1, currentDayOfMonth - (currentDayOfMonth === 1 && currentMonth === 0 ? 0 : 1))
    ],
    [DATE_PERIODS.LAST_YEAR]: [
        new Date(currentYear - 2, 0, 1),
        new Date(currentYear - 2, 12, 0)],
}

export const ACTUAL_PERIODS = {
    [DATE_PERIODS.YESTERDAY]: [getPreviousDate({ days: 2 }), getPreviousDate({ days: 2 })],
    [DATE_PERIODS.LAST_7_DAYS]: [getPreviousDate({ days: 7 }), getPreviousDate({ days: 1 })],
    [DATE_PERIODS.LAST_14_DAYS]: [getPreviousDate({ days: 14 }), getPreviousDate({ days: 1 })],
    [DATE_PERIODS.LAST_30_DAYS]: [getPreviousDate({ days: 30 }), getPreviousDate({ days: 1 })],
    [DATE_PERIODS.LAST_60_DAYS]: [getPreviousDate({ days: 60 }), getPreviousDate({ days: 1 })],
    [DATE_PERIODS.LAST_90_DAYS]: [getPreviousDate({ days: 90 }), getPreviousDate({ days: 1 })],
    [DATE_PERIODS.LAST_180_DAYS]: [getPreviousDate({ days: 180 }), getPreviousDate({ days: 1 })],
    [DATE_PERIODS.LAST_365_DAYS]: [getPreviousDate({ days: 365 }), getPreviousDate({ days: 1 })],
}

export const EVOLUTION_DATE_PERIODS = {
    [DATE_PERIODS.LAST_7_DAYS]: [getPreviousDate({ days: 7 }), getPreviousDate({ days: 0 })],
    [DATE_PERIODS.LAST_14_DAYS]: [getPreviousDate({ days: 14 }), getPreviousDate({ days: 0 })],
    [DATE_PERIODS.LAST_30_DAYS]: [getPreviousDate({ days: 30 }), getPreviousDate({ days: 0 })],
    [DATE_PERIODS.LAST_60_DAYS]: [getPreviousDate({ days: 60 }), getPreviousDate({ days: 0 })],
    [DATE_PERIODS.LAST_90_DAYS]: [getPreviousDate({ days: 90 }), getPreviousDate({ days: 0 })],
    [DATE_PERIODS.LAST_180_DAYS]: [getPreviousDate({ days: 180 }), getPreviousDate({ days: 0 })],
    [DATE_PERIODS.LAST_365_DAYS]: [getPreviousDate({ days: 365 }), getPreviousDate({ days: 0 })],
}


export const DATE_METRICS = {
    HOURLY: 'hour',
    DAILY: 'date',
    WEEKLY: 'week',
    MONTHLY: 'month',
    QUARTERLY: 'quarter',
    YEARLY: 'year'
}